import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    link: "User Management Video",
  },
  ja: {
    link: "ユーザー管理ビデオ",
  },
  es: {
    link: "Vídeo de Gestión de Usuarios",
  },
});

class User_Management_video extends Component {
  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const containerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const linkStyle = {
      textAlign: "center",
      textDecoration: "underline",
      color: "black",
    };

    return (
      <div style={containerStyle}>
        <a
          href="https://youtu.be/bBfEAZHu3LQ"
          target="_blank"
          style={linkStyle}
        >
          {localizationStrings.link}
        </a>
      </div>
    );
  }
}

export default User_Management_video;
